export const CREATE_Project = 'CREATE_Project ';

export const createProject = project => ({
    type: CREATE_Project,
    payload: {project}
});

export const REMOVE_Project = 'REMOVE_Project ';

export const removeProject = project => ({
    type: REMOVE_Project,
    payload: {project}
});
